import {
  FIRST_CONTRACT,
  OTC_CONTRACT,
  SECOND_CONTRACT,
  SWAP_CONTRACT,
} from "../constants";
import Web3 from "web3";
import { RelayProvider } from "@opengsn/provider";

// const paymasterAddress = "0xA6e10aA9B038c9Cddea24D2ae77eC3cE38a0c016";
const paymasterAddress = "0x707e618834062154F4262Ef11EbAC32D9E68c0Df";

export async function callPrivateSend(
  address: string,
  chainId: number,
  web3: any,
  amount: string,
  receiver: string,
  salt: string,
  isGlass: boolean,
  onSetModalText: any
) {
  try {
    onSetModalText("Requesting permission 1/2");
    const first_contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );
    const second_contract = new web3.eth.Contract(
      SECOND_CONTRACT.abi,
      SECOND_CONTRACT.address
    );

    var burnState = await first_contract.methods
      .VIEW_burn_Warning(receiver)
      .call({ from: address });

    if (burnState !== "") {
      return burnState;
    }
    await first_contract.methods.permit().send({ from: address });

    const ary = await second_contract.methods
      .requestInputs(
        receiver.toString(),
        web3.utils.toWei(amount).toString(),
        salt
      )
      .call({ from: address });

    var strAry: string[] = [];

    for (var i = 0; i < ary.length; i++) {
      strAry.push(ary[i]);
    }

    onSetModalText("Sending transaction 2/2");

    await first_contract.methods.sendTx(ary).send({ from: address });

    return "";
  } catch (error) {
    console.log("error    ", error);
    return "Invalid Transaction";
  } finally {
    onSetModalText("Waiting ...");
  }
}

export async function callGaslessSend(
  address: string,
  chainId: number,
  web3: any,
  amount: string,
  receiver: string,
  salt: string,
  onSetModalText: any
) {
  try {
    // const config = {
    //   paymasterAddress: paymasterAddress,
    //   jsonStringifyRequest: true,
    //   methodSuffix: "_v4",
    //   chainId: chainId,
    //   relayLookupWindowBlocks: 1e5,
    //   relayRegistrationLookupBlocks: 1e5,
    //   pastEventsQueryMaxPageSize: 2e4,
    //   trustedForwarder: "0x83A54884bE4657706785D7309cf46B58FE5f6e8a",
    // };

    const config = {
      paymasterAddress: paymasterAddress,
      jsonStringifyRequest: true,
      methodSuffix: "_v4",
      chainId: chainId,
      relayLookupWindowBlocks: 1e5,
      relayRegistrationLookupBlocks: 1e5,
      pastEventsQueryMaxPageSize: 2e4,
      trustedForwarder: "0xB2b5841DBeF766d4b521221732F9B618fCf34A87",
    };

    const provider = RelayProvider.newProvider({
      provider: web3.currentProvider,
      config,
    });
    await provider.init();

    let web3_: any = new Web3(provider as any);
    onSetModalText("Requesting permission...");

    const first_contract = new web3_.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );
    const second_contract = new web3.eth.Contract(
      SECOND_CONTRACT.abi,
      SECOND_CONTRACT.address
    );

    await first_contract.methods.permit().send({ from: address });

    const ary = await second_contract.methods
      .requestInputs(
        receiver.toString(),
        web3.utils.toWei(amount).toString(),
        salt
      )
      .call({ from: address });

    var strAry: string[] = [];

    for (var i = 0; i < ary.length; i++) {
      strAry.push(ary[i]);
    }

    onSetModalText("Sending transaction...");

    await first_contract.methods
      .sendTxGasless(ary)
      .send({ from: address, gasLimit: "200000" });
    return true;
  } catch (error) {
    console.log("error    ", error);
    return false;
  } finally {
    onSetModalText("Waiting ...");
  }
}

export async function callChangeInstructed(
  address: string,
  chainId: number,
  web3: any,
  state: boolean
) {
  try {
    const first_contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );
    await first_contract.methods
      .changeInstructed(state)
      .send({ from: address });
    return true;
  } catch (error) {
    console.log("error    ", error);
    return false;
  }
}

export async function callChangedePrivatize(
  address: string,
  chainId: number,
  web3: any,
  state: boolean
) {
  try {
    const first_contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );

    await first_contract.methods
      .change_dePrivatize(state)
      .send({ from: address });

    return true;
  } catch (error) {
    console.log("error    ", error);
    return false;
  }
}

export async function callDecrypt(address: string, chainId: number, web3: any) {
  try {
    const first_contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );

    await first_contract.methods.decrypt().send({ from: address });

    return true;
  } catch (error) {
    console.log("error    ", error);
    return false;
  }
}

export function callBalanceOf(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );
    await contract.methods
      .balanceOf(address)
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export async function callDePrivatizeCheck(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    FIRST_CONTRACT.abi,
    FIRST_CONTRACT.address
  );

  try {
    const result = await contract.methods
      .dePrivatize_check()
      .call({ from: address });
    return { result: result as boolean, error: "" };
  } catch (error) {
    return { result: false, error };
  }

  // return new Promise(async (resolve, reject) => {
  //   // const contract = new web3.eth.Contract(
  //   //   FIRST_CONTRACT.abi,
  //   //   FIRST_CONTRACT.address
  //   // );

  //   await contract.methods
  //     .dePrivatize_check()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export async function callDecoyValue(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    FIRST_CONTRACT.abi,
    FIRST_CONTRACT.address
  );
  try {
    const result: boolean = await contract.methods
      .returnModeOnlyToUser()
      .call({ from: address });
    return { result: result as boolean, error: "" };
  } catch (error) {
    return { result: false, error };
  }

  // return new Promise(async (resolve, reject) => {
  //   const contract = new web3.eth.Contract(
  //     FIRST_CONTRACT.abi,
  //     FIRST_CONTRACT.address
  //   );

  //   await contract.methods
  //     .returnModeOnlyToUser()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export function callEarnestArrow(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      FIRST_CONTRACT.abi,
      FIRST_CONTRACT.address
    );

    await contract.methods
      .earnestArrow(address)
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export async function callShowCurrentTier(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    OTC_CONTRACT.abi,
    OTC_CONTRACT.address
  );

  try {
    const result = await contract.methods
      .showCurrentTier()
      .call({ from: address });
    return { result: result, error: null };
  } catch (error) {
    return { result: false, error };
  }
  // return new Promise(async (resolve, reject) => {
  //   const contract = new web3.eth.Contract(
  //     OTC_CONTRACT.abi,
  //     OTC_CONTRACT.address
  //   );

  //   await contract.methods
  //     .showCurrentTier()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export async function callShowCurrentTierPrice(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    OTC_CONTRACT.abi,
    OTC_CONTRACT.address
  );

  try {
    const result = await contract.methods
      .showPriceofCurrentTier()
      .call({ from: address });
    return { result: result, error: null };
  } catch (error) {
    return { result: false, error };
  }

  // return new Promise(async (resolve, reject) => {
  //   const contract = new web3.eth.Contract(
  //     OTC_CONTRACT.abi,
  //     OTC_CONTRACT.address
  //   );

  //   await contract.methods
  //     .showPriceofCurrentTier()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export async function callShowWhatLeftInTier(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    OTC_CONTRACT.abi,
    OTC_CONTRACT.address
  );

  try {
    const result = await contract.methods
      .showWhatsLeftinTier()
      .call({ from: address });
    return { result: result, error: null };
  } catch (error) {
    return { result: false, error };
  }
  // return new Promise(async (resolve, reject) => {
  //   const contract = new web3.eth.Contract(
  //     OTC_CONTRACT.abi,
  //     OTC_CONTRACT.address
  //   );

  //   await contract.methods
  //     .showWhatsLeftinTier()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export async function callShowBV3Amount(address: string, web3: any) {
  const contract = new web3.eth.Contract(
    OTC_CONTRACT.abi,
    OTC_CONTRACT.address
  );

  try {
    const result = await contract.methods
      .showHOWMUCHBV3()
      .call({ from: address });
    return { result: result, error: null };
  } catch (error) {
    return { result: false, error };
  }
  // return new Promise(async (resolve, reject) => {
  //   const contract = new web3.eth.Contract(
  //     OTC_CONTRACT.abi,
  //     OTC_CONTRACT.address
  //   );

  //   await contract.methods
  //     .showHOWMUCHBV3()
  //     .call({ from: address }, (err: any, data: any) => {
  //       if (err) {
  //         reject(err);
  //       }
  //       resolve(data);
  //     });
  // });
}

export async function callSendEtheronOTC(
  address: string,
  web3: any,
  amount: string
) {
  try {
    await web3.eth.sendTransaction({
      from: address,
      to: OTC_CONTRACT.address,
      value: web3.utils.toWei(amount).toString(),
    });
    return true;
  } catch {
    return false;
  }
}

export function callShowTortugaETH(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .displayETH()
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export function callShowSwappableUSDT(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .returnSwapableMaximumExactly()
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export function callShowMaxSwappableBV3(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .maximum_swappable()
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export function callShowMinSwappableBV3(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .return_Minimum_Swap_BV3A()
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export function callShowCurrentBV3Price(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .returnBv3inDollars("1000000000000000000")
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export function callShowTortuaSwapFee(address: string, web3: any) {
  return new Promise(async (resolve, reject) => {
    const contract = new web3.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    await contract.methods
      .returnFEEVIEW_in_ETH()
      .call({ from: address }, (err: any, data: any) => {
        if (err) {
          reject(err);
        }
        resolve(data);
      });
  });
}

export async function callConductSwap(
  address: string,
  web3: any,
  amount: string
) {
  try {
    const config = {
      paymasterAddress: paymasterAddress,
      // jsonStringifyRequest: true,
      // gasPriceFactorPercent: 20,
      preferredRelays: ["https://bv3arelayer.com"],
      blacklistedRelays: ["https://arbitrum.3-0-0-beta-3.opengsn.org/v3"],
      // methodSuffix: "_v4",
      // chainId: 42161,
      // relayLookupWindowBlocks: 1e5,
      // relayRegistrationLookupBlocks: 1e5,
      // pastEventsQueryMaxPageSize: 2e4,
      trustedForwarder: "0xB2b5841DBeF766d4b521221732F9B618fCf34A87",
      // gasPriceSlackPercent: 900,
      // calldataEstimationSlackFactor: 50,
      // minMaxPriorityFeePerGas: 10**9,
      performDryRunViewRelayCall: false,
      maxViewableGasLimit: "25000000",
      // performEstimateGasFromRealSender: true,
      // gasPriceOracleUrl: "https://arbitrum.3-0-0-beta-3.opengsn.org/v3/getaddr",
      // gasPriceOraclePath: "minMaxPriorityFeePerGas"
    };

    const gsnProvider = RelayProvider.newProvider({
      provider: web3.currentProvider,
      config,
    });
    await gsnProvider.init();

    let web3_: any = new Web3(gsnProvider as any);

    const contract = new web3_.eth.Contract(
      SWAP_CONTRACT.abi,
      SWAP_CONTRACT.address
    );

    const response = await contract.methods
      .conductSwap(web3_.utils.toWei(amount).toString())
      .send({
        from: address,
        maxPriorityFeePerGas: 1,
        maxFeePerGas: 10 ** 8,
        gasLimit: 25_000_000,
      });

    console.log({ response });

    return true;
  } catch {
    return false;
  }
}
